import { Inject, Injectable, InjectionToken } from '@angular/core';
import Pusher from 'pusher-js';
import {
  ChannelAuthorizationCallback,
  ChannelAuthorizationHandler,
  ChannelAuthorizationRequestParams,
} from 'pusher-js/src/core/auth/options';
import { pusherContract } from '@thred/shared-common';
import { initClient, InitClientArgs } from '@ts-rest/core';
import { HttpClient } from '@angular/common/http';
import { getTsRestClient } from './get-ts-rest-client';
import { DefaultNgAppEnvironment, PusherEnv } from './environment';

export type PusherClientContainer = {
  client: ReturnType<typeof initClient<typeof pusherContract, InitClientArgs>>;
  clientId: string;
  cluster: string;
};
export const PUSHER_CLIENT_TOKEN = new InjectionToken<PusherClientContainer>(
  'PUSHER_CLIENT_TOKEN',
);

export function getPusherProvider(
  apiUrl: DefaultNgAppEnvironment['apiUrl'],
  pusher: PusherEnv,
) {
  return {
    provide: PUSHER_CLIENT_TOKEN,
    useFactory: (httpClient: HttpClient): PusherClientContainer => {
      return {
        client: getTsRestClient(apiUrl, pusherContract, httpClient),
        ...pusher,
      };
    },
    deps: [HttpClient],
  };
}

@Injectable({
  providedIn: 'root',
})
export class PusherNgService {
  public pusherClient: Pusher;
  constructor(
    @Inject(PUSHER_CLIENT_TOKEN) private clientContainer: PusherClientContainer,
  ) {
    const channelAuthorizationHandler: ChannelAuthorizationHandler = (
      params: ChannelAuthorizationRequestParams,
      callback: ChannelAuthorizationCallback,
    ) => {
      this.clientContainer.client
        .channelAuth({
          body: {
            socketId: params.socketId,
            channelName: params.channelName,
          },
        })
        .then(
          (r) => {
            if (r.status == 200) {
              return callback(null, r.body);
            }
            console.error(r);
            callback(new Error('unknown status'), null);
          },
          (e) => callback(e, null),
        );
    };

    // todo: use env
    this.pusherClient = new Pusher(clientContainer.clientId, {
      cluster: clientContainer.cluster,
      forceTLS: true,
      channelAuthorization: {
        transport: 'ajax',
        endpoint: '',
        customHandler: channelAuthorizationHandler,
      },
    });

    // var channel = this.pusherClient.subscribe('private-my-channel');
    // channel.bind('my-event', function (data: any) {
    //   console.log('from private pusher:', data);
    // });
  }
}
